<template>
  <div class="main-container">
    <div class="main-content-wrap">
      <div class="main-content-pannel">
        <div class="flex flex-row">
          <div
            class="fixed-height-content bg-grey-lightest"
            style="width: 320px"
          >
            <div class="bg-grey-lightest" style="position: fixed; width: 320px">
              <div
                class="
                  pannel-out-title pannel-out-title-small
                  m-t-l m-l-l m-r-l
                "
              >
                <h3>Consultants</h3>
                <div class="pannel-out-option">
                  <a
                    style="background-color: transparent; box-shadow: none"
                    class="btn border-0 cursor-pointer"
                    href="javascript:void(0);"
                    @click="addAll"
                  >
                    Add All</a
                  >
                </div>
                <div class="pannel-out-option">
                  <a
                    style="background-color: transparent; box-shadow: none"
                    class="btn border-0 cursor-pointer"
                    href="javascript:void(0);"
                    @click="toggleFilter"
                    ><i class="material-icons align-middle">filter_list</i>
                    Filter</a
                  >
                </div>
              </div>
              <div class="m-t m-l-l m-r-l">
                <div class="searchbox m-0">
                  <label for="clientFilter">
                    <i
                      v-if="!searchFilter"
                      class="material-icons-outlined align-middle"
                      style="top: 12px"
                      >search</i
                    >
                    <i
                      v-else
                      @click="searchFilter = ''"
                      class="material-icons-outlined align-middle"
                      style="top: 12px"
                      >clear</i
                    >
                  </label>
                  <input
                    style="width: 222px"
                    id="clientFilter"
                    type="text"
                    @keyup="onSearchFilter"
                    :value="searchFilter"
                    placeholder="Search"
                  />
                </div>
              </div>
              <div
                style="overflow-y: auto; height: calc(100vh - 200px)"
                class="m-t-l"
              >
                <div
                  class="m-l-l m-r-l"
                  v-for="(techLevel, index) in Object.keys(data)"
                  :key="index"
                >
                  <div
                    class="
                      pannel-1 pannel-1-padding
                      m-b
                      relative
                      action-wrapper
                      techStatus
                    "
                    v-for="techData in data[techLevel]"
                    :key="techData.id"
                    @click="selectTech(techData)"
                    :class="{
                      'client-active':
                        consultant && consultant.id == techData.id,
                    }"
                  >
                    <div class="pannel-1-title">
                      <div style="width: 100%">
                        <h3>
                          <div class="project-company-avatar flex m-r">
                            <div
                              class="
                                project-company-avatar-container
                                rounded-full
                              "
                            >
                              <span v-if="!techData.photo_url">{{
                                (techData.name ? techData.name : techData.email)
                                  | getFirstLetter
                              }}</span>
                              <img v-else :src="techData.photo_url" alt />
                            </div>
                          </div>
                          <div class="flex-1">
                            {{ techData.name }}

                            <i
                              class="
                                material-icons
                                align-middle
                                font-color-lighter
                              "
                              v-if="
                                (techData.client_confirm ||
                                  techData.reply === 'yes') &&
                                !(
                                  techData.client_confirm &&
                                  techData.reply === 'yes'
                                )
                              "
                              >check</i
                            >
                            <i
                              class="
                                material-icons
                                align-middle
                                font-color-lighter
                              "
                              v-if="
                                techData.client_confirm &&
                                techData.reply === 'yes'
                              "
                              >done_all</i
                            >
                            <i
                              class="
                                material-icons
                                align-middle
                                font-color-green
                              "
                              v-if="techData.verified"
                              >verified</i
                            >
                          </div>
                        </h3>
                      </div>
                    </div>
                    <div class="hr"></div>
                    <div>
                      <div class="pannel-1-body p-b-0">
                        <p>{{ techData.bio }}</p>
                      </div>

                      <div v-if="techData.work_type">
                        <div
                          v-for="wt in techData.work_type.split(',')"
                          :key="wt"
                        >
                          <span class="wt_lvl_tag"
                            ><i class="material-icons align-middle"
                              >account_balance_wallet</i
                            >{{ wt }}</span
                          >
                        </div>
                      </div>

                      <div class="pannel-1-footer">
                        <div>
                          <span v-if="techData.tech_level" class="tech_lvl_tag"
                            ><i class="material-icons align-middle">stream</i
                            >{{ techData.tech_level }}</span
                          >
                        </div>
                        <div class="pannel-1-footer-option">
                          <span class="font-color-lighter font-lg">{{
                            techData.rate | currencyFilter("$", 2)
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="flex-1">
            <div v-if="consultant" class="bg-white, flex-1">
              <div class="option-wrap no-border" style="height: 80px">
                <div class="options">
                  <div class="content-title-wrap p-t-0 title-wrapper">
                    <div class="main-content-title">
                      <div class="main-content-title-person">
                        <div class="avatar-container">
                          <div class="avatar">
                            <span v-if="!consultant.photo_url">{{
                              (consultant.name
                                ? consultant.name
                                : consultant.email) | getFirstLetter
                            }}</span>
                            <img v-else :src="consultant.photo_url" alt />
                          </div>
                          <span
                            class="status-pill avatar-ative"
                            :class="{
                              red: !consultant.is_active,
                              green: consultant.is_active,
                            }"
                            :title="
                              consultant.is_active ? 'Active' : 'Inactive'
                            "
                          ></span>
                        </div>
                        <div class="connsultant-resume-info">
                          <div class="connsultant-resume-name">
                            <div>{{ consultant.name }}</div>
                            <i
                              class="
                                material-icons
                                align-middle
                                font-color-lighter
                              "
                              v-if="
                                (consultant.client_confirm ||
                                  consultant.reply === 'yes') &&
                                !(
                                  consultant.client_confirm &&
                                  consultant.reply === 'yes'
                                )
                              "
                              >check</i
                            >
                            <i
                              class="
                                material-icons
                                align-middle
                                font-color-lighter
                              "
                              v-if="
                                consultant.client_confirm &&
                                consultant.reply === 'yes'
                              "
                              >done_all</i
                            >
                            <i
                              class="
                                material-icons
                                align-middle
                                font-color-green
                              "
                              v-if="consultant.verified"
                              >verified</i
                            >
                          </div>
                          <div class="connsultant-resume-location flex">
                            <span class="tech_lvl_tag"
                              ><i class="material-icons align-middle">stream</i
                              >{{ consultant.tech_level }}</span
                            >
                            <i class="material-icons align-middle"
                              >location_on</i
                            >
                            {{ consultant.metro }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="buttons-wrapper">
                      <div class="button" @click="viewAsConsultant(consultant)">
                        View As
                      </div>
                      <router-link
                        :to="{
                          name: 'resume',
                          params: { id: consultant.id, type: 'allinfo' },
                        }"
                        target="_blank"
                        ><div class="button">Resume</div></router-link
                      >
                      <div class="button" @click="onClickProject(consultant)">
                        Project
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="main-flex m-t-4l">
                <div class="main-flex-1 flex-left">
                  <div class="pannel-1 border-radius-none">
                    <div class="pannel-1-title">
                      <h3>Bio</h3>
                      <!--                      <div class="pannel-1-title-option">-->
                      <!--                        <a class="btn" href="javascript:void(0);"-->
                      <!--                           @click="openEditPannel(10, true)"-->
                      <!--                           :class="{ active: editOpen == 10 }"-->
                      <!--                           title="Edit Bio"-->
                      <!--                        >Edit</a-->
                      <!--                        >-->
                      <!--                      </div>-->
                    </div>
                    <div class="pannel-1-body">
                      <p class="preline">{{ consultant.bio }}</p>
                    </div>
                  </div>
                  <div
                    class="pannel-1 border-radius-none relative"
                    style="min-height: 150px"
                    v-if="
                      consultant.interview_url ||
                      (user && user.roles && user.roles.admin)
                    "
                  >
                    <div v-if="consultant.interview_url">
                      <iframe
                        class="video-wrapper iframe-wrapper"
                        :src="consultant.interview_url"
                      />
                    </div>
                    <div class="pannel-1-title pannel-1-title-float">
                      <!--                      <h3><a class="btn" href="javascript:void()">Video Interview</a></h3>-->
                      <!--                      <div class="pannel-1-title-option">-->
                      <!--                        <a class="btn" href="javascript:void(0);"-->
                      <!--                           @click="openEditPannel(9, true)"-->
                      <!--                           :class="{ active: editOpen == 9 }"-->
                      <!--                           title="Edit Video"-->
                      <!--                        >Edit</a-->
                      <!--                        >-->
                      <!--                      </div>-->
                    </div>
                  </div>

                  <div class="pannel-1 border-radius-none">
                    <div class="pannel-1-title">
                      <h3>Certifications</h3>
                      <!--                      <div class="pannel-1-title-option">-->
                      <!--                        <a class="btn" href="javascript:void(0);"-->
                      <!--                           @click="openEditPannel(1, true)"-->
                      <!--                           :class="{ active: editOpen == 1 }"-->
                      <!--                        >Edit</a-->
                      <!--                        >-->
                      <!--                      </div>-->
                    </div>
                    <div class="pannel-1-body tech-cert-content">
                      <ul
                        v-if="
                          consultant.resume && consultant.resume.certifications
                        "
                      >
                        <li
                          v-for="(certification, index) in consultant.resume
                            .certifications"
                          :key="index"
                        >
                          <a
                            href="javascript:void(0)"
                            class="flex items-center"
                            @click="onClickCertification(index)"
                          >
                            <div
                              class="image"
                              :style="{
                                backgroundImage: `url(${certification.image_url}`,
                              }"
                            ></div>
                            <div
                              class="flex-1"
                              style="color: var(--font-color-lighter; font-weight: 800"
                            >
                              {{ certification.description }}
                            </div>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="pannel-1 border-radius-none">
                    <div class="pannel-1-title">
                      <h3>Skills</h3>
                      <!--                      <div class="pannel-1-title-option">-->
                      <!--                        <a class="btn" href="javascript:void(0);"-->
                      <!--                           @click="openEditPannel(2, true)"-->
                      <!--                           :class="{ active: editOpen == 2 }"-->
                      <!--                        >Edit</a-->
                      <!--                        >-->
                      <!--                      </div>-->
                    </div>
                    <div class="pannel-1-body tech-cert-content">
                      <ul
                        class="tech-skill-content"
                        v-if="consultant.resume && consultant.resume.skills"
                      >
                        <li
                          v-for="(skill, index) in consultant.resume.skills"
                          :key="index"
                        >
                          <a href="javascript:void(0)">
                            {{ skill }}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="pannel-1 border-radius-none">
                    <div class="pannel-1-title">
                      <h3>Tools</h3>
                      <!--                      <div class="pannel-1-title-option">-->
                      <!--                        <a class="btn" href="javascript:void(0);"-->
                      <!--                           @click="openEditPannel(3, true)"-->
                      <!--                           :class="{ active: editOpen == 3 }"-->
                      <!--                        >Edit</a-->
                      <!--                        >-->
                      <!--                      </div>-->
                    </div>
                    <div class="pannel-1-body tech-cert-content">
                      <ul
                        class="tech-skill-content"
                        v-if="consultant.resume && consultant.resume.tools"
                      >
                        <li
                          v-for="(tool, index) in consultant.resume.tools"
                          :key="index"
                        >
                          <a
                            href="javascript:void(0)"
                            @click="onClickTool(index)"
                            >{{
                              typeof tool === "string" ? tool : tool.name
                            }}</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="main-flex-2">
                  <div class="pannel-1 border-radius-none">
                    <div class="pannel-1-title">
                      <h3>Work History</h3>
                      <!--                      <div class="pannel-1-title-option">-->
                      <!--                        <a class="btn" href="javascript:void(0);"-->
                      <!--                           @click="openEditPannel(4, true)"-->
                      <!--                           :class="{ active: editOpen == 4 }"-->
                      <!--                        >add Work Experience</a-->
                      <!--                        >-->
                      <!--                      </div>-->
                    </div>
                    <div class="hr m-t"></div>
                    <div class="pannel-1-body">
                      <section
                        v-if="
                          consultant.resume && consultant.resume.work_histories
                        "
                      >
                        <div
                          v-for="(workHistory, index) in consultant.resume
                            .work_histories"
                          :key="index"
                          class="work-history-experience"
                        >
                          <div class="flex justify-content-between">
                            <div class="work-history-info">
                              <h6>{{ workHistory.company_name }}</h6>
                              <h5>{{ workHistory.job }}</h5>
                              <div>
                                <span
                                  >{{
                                    workHistory.start_time
                                      | dateformatFilter("MMM YYYY")
                                  }}
                                  -
                                  {{
                                    workHistory.end_time
                                      | dateformatFilter("MMM YYYY", true)
                                  }}</span
                                >
                                <i class="material-icons align-middle">place</i>
                                {{ workHistory.location }}
                              </div>
                            </div>
                            <div
                              class="work-history-image"
                              :style="{
                                backgroundImage: `url(${workHistory.image_url}`,
                              }"
                              v-if="workHistory.image_url"
                            ></div>
                          </div>

                          <div class="flex-1">
                            <p
                              v-for="(
                                experience, idx
                              ) in workHistory.experiences"
                              :key="idx"
                              class="preline"
                            >
                              {{ experience }}
                            </p>
                            <!--                            <div class="tech-resume-timeline-action">-->
                            <!--                              <a-->
                            <!--                                  href="javascript:void(0)"-->
                            <!--                                  @click="editWorkHistory(index)"-->
                            <!--                              >-->
                            <!--                                <i class="material-icons-outlined align-middle">edit</i>-->
                            <!--                              </a>-->
                            <!--                              <a-->
                            <!--                                  href="javascript:void(0)"-->
                            <!--                                  @click="deleteWorkHistory(index)"-->
                            <!--                              >-->
                            <!--                                <i class="material-icons-outlined align-middle"-->
                            <!--                                >delete</i-->
                            <!--                                >-->
                            <!--                              </a>-->
                            <!--                            </div>-->
                          </div>

                          <div
                            class="hr m-t-2l"
                            style="margin-left: -20px; margin-right: -20px"
                          ></div>
                        </div>
                      </section>
                    </div>
                  </div>

                  <div class="pannel-1 border-radius-none">
                    <div class="pannel-1-title">
                      <h3>Educations</h3>
                      <!--                      <div class="pannel-1-title-option">-->
                      <!--                        <a class="btn" href="javascript:void(0);"-->
                      <!--                           @click="openEditPannel(6, true)"-->
                      <!--                           :class="{ active: editOpen == 6 }"-->
                      <!--                        >add Education</a-->
                      <!--                        >-->
                      <!--                      </div>-->
                    </div>
                    <div class="hr m-t"></div>
                    <div class="pannel-1-body">
                      <section
                        v-if="consultant.resume && consultant.resume.educations"
                      >
                        <div
                          v-for="(education, index) in consultant.resume
                            .educations"
                          :key="index"
                          class="work-history-experience"
                        >
                          <div class="flex justify-content-between">
                            <div class="work-history-info">
                              <h6>{{ education.school_name }}</h6>
                              <h5>{{ education.major }}</h5>
                              <div>
                                <span
                                  >{{
                                    education.start_time
                                      | dateformatFilter("MMM YYYY")
                                  }}
                                  -
                                  {{
                                    education.end_time
                                      | dateformatFilter("MMM YYYY", true)
                                  }}</span
                                >
                                <i class="material-icons align-middle">place</i>
                                {{ education.location }}
                              </div>
                            </div>
                            <div
                              class="work-history-image"
                              :style="{
                                backgroundImage: `url(${education.image_url}`,
                              }"
                              v-if="education.image_url"
                            ></div>
                          </div>

                          <div class="flex-1">
                            <p
                              v-for="(experience, idx) in education.experiences"
                              :key="idx"
                              class="preline"
                            >
                              {{ experience }}
                            </p>
                            <!--                            <div class="tech-resume-timeline-action">-->
                            <!--                              <a-->
                            <!--                                  href="javascript:void(0)"-->
                            <!--                                  @click="editEducation(index)"-->
                            <!--                              >-->
                            <!--                                <i class="material-icons-outlined align-middle">edit</i>-->
                            <!--                              </a>-->
                            <!--                              <a-->
                            <!--                                  href="javascript:void(0)"-->
                            <!--                                  @click="deleteEducation(index)"-->
                            <!--                              >-->
                            <!--                                <i class="material-icons-outlined align-middle"-->
                            <!--                                >delete</i-->
                            <!--                                >-->
                            <!--                              </a>-->
                            <!--                            </div>-->
                          </div>

                          <div
                            class="hr m-t-2l"
                            style="margin-left: -20px; margin-right: -20px"
                          ></div>
                        </div>
                      </section>
                    </div>
                  </div>

                  <div class="pannel-1 border-radius-none">
                    <div class="pannel-1-title">
                      <h3>References</h3>
                      <!--                      <div class="pannel-1-title-option">-->
                      <!--                        <a class="btn" href="javascript:void(0);"-->
                      <!--                           @click="openEditPannel(8, true)"-->
                      <!--                           :class="{ active: editOpen == 8 }"-->
                      <!--                        >add References</a-->
                      <!--                        >-->
                      <!--                      </div>-->
                    </div>
                    <div class="hr m-t"></div>
                    <div class="pannel-1-body">
                      <ul
                        class="blockquote"
                        v-if="consultant.resume && consultant.resume.references"
                      >
                        <li
                          v-for="(reference, index) in consultant.resume
                            .references"
                          :key="index"
                        >
                          <p>
                            {{ reference.content }}
                            <span>{{ reference.signature }}</span>
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <transition name="edit-pannel">
        <edit-pannel v-model="editOpen" title>
          <TechFilter
            v-if="editOpen == 1"
            @closePanel="closeEditPannel"
            :metroOptions="metroOptions"
            :skillOptions="skillOptions"
            :certificationOptions="certificationOptions"
            :levelOptions="levelOptions"
            :metroFilter="metroFilter"
            :certificationFilter="certificationFilter"
            :skillFilter="skillFilter"
            :levelFilter="levelFilter"
            :workTypeFilter="workTypeFilter"
            :notWorkTypeFilter="notWorkTypeFilter"
            :searchFilter="searchFilter"
            :workTypes="workTypes"
            :notWorkTypes="notWorkTypes"
            :verified="verified"
            :isActive="isActive"
            @buttonClick="onFilter"
          ></TechFilter>
          <PanelRequest
            v-if="editOpen == 2"
            :propsData="requestPropsData"
            :submitLoading="requestSubmitLoading"
            @buttonClick="onRequestButtonClick"
          ></PanelRequest>
          <PanelProject
            v-if="editOpen == 3"
            :projectOptions="projectOptions"
            :projectToRoles="projectToRoles"
            :submitLoading="projectSubmitLoading"
            :addType="addType"
            @buttonClick="onProjectButtonClick"
          ></PanelProject>
        </edit-pannel>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { db } from "@/vendor/firebase";
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import EditPannel from "@/components/EditPannel.vue";
import OptionMenu from "@/components/OptionMenu.vue";
import PanelRequest from "@/components/client/clientAvailableTechs/PanelRequest.vue";
import PanelProject from "@/components/client/clientAvailableTechs/PanelProject.vue";
import * as database from "@/vendor/database";
import { httpGetNoToken, httpGet } from "@/http/http";
import moment from "moment-timezone";
import TechFilter from "@/components/ActiveTechFilter";
import CryptoJS from "crypto-js";

export default {
  props: ["editOpenTitle"],
  data() {
    return {
      consultant: null,
      consultants: null,
      techLevels: null,
      levelstatus: null,
      data: [],
      metroOptions: [],
      metroItem: {
        text: "",
        value: "",
      },
      techLevelsSort: null,
      searchText: null,
      clientId: null,
      metroSearch: null,
      editOpen: false,
      requestPropsData: null,
      clientEmail: null,
      requestSubmitLoading: false,
      skillOptions: [],
      certificationOptions: [],
      projectOptions: [],
      projectToRoles: new Map(),
      projectSubmitLoading: false,
      levelOptions: [],
      metroFilter: null,
      certificationFilter: null,
      skillFilter: null,
      levelFilter: null,
      workTypeFilter: "",
      notWorkTypeFilter: "",
      workTypes: [],
      notWorkTypes: [],
      editConsultantId: null,
      addType: "one",
      searchFilter: "",
      verified: null,
      isActive: true,
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  components: {
    ModelSelect,
    EditPannel,
    OptionMenu,
    PanelRequest,
    PanelProject,
    TechFilter,
  },
  watch: {
    editOpenTitle: function (val) {
      this.editOpen = val;
    },
    consultants: function () {
      this.updateData();
    },
    techLevels: function () {
      this.updateData();
    },
  },
  beforeMount() {
    // return;
    this.getUrlParams();
    this.bindData();
  },
  methods: {
    onClickCertification: function (index) {
      const link = this.consultant.resume.certifications[index].link;
      if (link) window.open(link, "_blank");
    },
    onClickTool: function (index) {
      if (typeof this.consultant.resume.tools[index] == "object") {
        const link = this.consultant.resume.tools[index].link;
        if (link) window.open(link, "_blank");
      }
    },
    selectTech: function (item) {
      if (item) {
        this.consultant = item;
      }
    },
    getUrlParams: function () {
      this.clientId = this.$route.query.id;
      if (this.clientId) {
        database.getDoc("companies", this.clientId).then((result) => {
          if (result.ok && result.data.data.email) {
            this.clientEmail = result.data.data.email;
          }
        });
      }
      const metro = this.$route.query.metro;
      if (metro && metro !== "all") {
        this.metroItem = {
          text: metro,
          value: metro,
        };
      } else {
        this.metroItem = {
          text: "ALL",
          value: null,
        };
      }
      if (this.$route.query.search) {
        this.searchText = this.$route.query.search;
      }
    },
    toggleCollapse: function (techLevel) {
      this.levelstatus[techLevel] = !this.levelstatus[techLevel];
      this.$forceUpdate();
    },
    bindData: function () {
      this.initMetroOptions();
      this.initSkillOptions();
      this.initCertificationOptions();
      this.initConsultants();
      this.initTechLevels();
      this.initProjects();
      this.initWorkTypes();
    },
    initConsultants: function () {
      db.collection("consultants")
        .get()
        .then((querySnapshot) => {
          this.consultants = querySnapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }));
        });
    },
    initTechLevels: function () {
      const levelArray = [
        {
          text: "ALL(Levels)",
          value: null,
        },
      ];
      db.collection("tech_levels")
        .get()
        .then((querySnapshot) => {
          this.techLevels = querySnapshot.docs.map((doc) => doc.data());
          this.techLevels.forEach((item) => {
            levelArray.push({
              text: item.name,
              value: item.name,
            });
          });
          this.levelOptions = levelArray;
          this.$forceUpdate();
        });
    },
    initMetroOptions: function () {
      const metroArray = [
        {
          text: "ALL(Metros)",
          value: null,
        },
      ];
      db.collection("metros")
        .get()
        .then((querySnapshot) => {
          const documents = querySnapshot.docs.map((doc) => doc.data());
          documents.forEach((metro, index) => {
            metroArray.push({
              text: metro.name,
              value: metro.name,
            });
          });
          this.metroOptions = metroArray;
          this.$forceUpdate();
        });
    },
    initSkillOptions: function () {
      db.collection("skills")
        .get()
        .then((querySnapshot) => {
          this.skillOptions = [
            {
              text: "ALL(Skills)",
              value: null,
            },
          ].concat(
            querySnapshot.docs.map((doc) => ({
              text: doc.data().name,
              value: doc.data().name,
            }))
          );
          this.$forceUpdate();
        });
    },
    initCertificationOptions: function () {
      db.collection("certifications")
        .get()
        .then((querySnapshot) => {
          this.certificationOptions = [
            {
              text: "ALL(Certifications)",
              value: null,
            },
          ].concat(
            querySnapshot.docs.map((doc) => ({
              text: doc.data().description,
              value: doc.data().description,
            }))
          );
          this.$forceUpdate();
        });
    },
    initProjects: function () {
      const p1 = db.collection("gigs").get();
      const p2 = db.collection("companies").get();
      Promise.all([p1, p2]).then((res) => {
        let projects = res[0].docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        const companies = res[1].docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        this.projectOptions = [];
        projects = projects.sort((a, b) => {
          return b.created - a.created;
        });
        projects.forEach((item) => {
          if (item.roles && item.roles.length > 0) {
            let companyName;
            if (item.company) {
              const company = companies.find((c) => c.id === item.company);
              if (company) {
                companyName = company.name;
              }
            }
            this.projectOptions.push({
              // text: "text",
              text: companyName ? `(${companyName}) ${item.title}` : item.title,
              value: item.id,
            });
            this.projectToRoles.set(
              item.id,
              item.roles.map((item) => ({
                text: item.title,
                value: item.id,
              }))
            );
          }
        });
      });
    },
    initWorkTypes: function () {
      db.collection("new_work_types")
        .get()
        .then((querySnapshot) => {
          this.workTypes = querySnapshot.docs.map((doc) => ({
            text: doc.data().name,
            value: false,
          }));
          this.notWorkTypes = querySnapshot.docs.map((doc) => ({
            text: doc.data().name,
            value: false,
          }));
          this.$forceUpdate();
        });
    },
    updateData: function () {
      if (this.consultants && this.techLevels) {
        this.data = {};
        this.techLevelsSort = this.techLevels.slice();
        this.techLevelsSort.sort((a, b) => {
          if (a.order === null || a.order === undefined) return 1;
          if (b.order === null || b.order === undefined) return -1;
          return a.order - b.order;
        });
        this.levelstatus = {};
        for (const i in this.techLevelsSort) {
          if (!this.data[this.techLevelsSort[i].name]) {
            this.data[this.techLevelsSort[i].name] = [];
            this.levelstatus[this.techLevelsSort[i].name] = true;
          }
        }
        this.data["general"] = [];
        this.levelstatus["general"] = true;
        for (const i in this.consultants) {
          if (this.consultants[i].created) {
            this.consultants[i].createdString = moment(
              this.consultants[i].created * 1000
            ).format("MM/DD/YYYY");
          }
          if (this.consultants[i].resume && this.consultants[i].resume.skills) {
            const skills = this.consultants[i].resume.skills;
            if (skills.indexOf("Windows OS") > -1)
              this.consultants[i].windows = true;
            if (skills.indexOf("Mac OS") > -1) this.consultants[i].mac = true;
            if (skills.indexOf("Linux OS") > -1)
              this.consultants[i].linux = true;
          }
          if (
            this.isActive === null ||
            !!this.consultants[i].is_active === !!this.isActive
          ) {
            if (
              !this.skillFilter ||
              (this.skillFilter &&
                this.consultants[i].resume &&
                this.consultants[i].resume.skills &&
                this.consultants[i].resume.skills.indexOf(this.skillFilter) >
                  -1)
            ) {
              if (
                !this.certificationFilter ||
                (this.certificationFilter &&
                  this.consultants[i].resume &&
                  this.consultants[i].resume.certifications &&
                  this.consultants[i].resume.certifications.some(
                    (item) => item.description === this.certificationFilter
                  ))
              ) {
                if (
                  !this.metroFilter ||
                  this.consultants[i].metro === this.metroFilter
                ) {
                  if (
                    !this.levelFilter ||
                    this.consultants[i].tech_level === this.levelFilter
                  ) {
                    if (
                      !this.workTypeFilter ||
                      this.hasWorkType(
                        this.consultants[i].work_type,
                        this.workTypeFilter
                      )
                    ) {
                      if (
                        !this.notWorkTypeFilter ||
                        this.hasNotWorkType(
                          this.consultants[i].work_type,
                          this.notWorkTypeFilter
                        )
                      ) {
                        if (
                          !this.searchFilter ||
                          JSON.stringify(this.consultants[i])
                            .toLowerCase()
                            .indexOf(this.searchFilter.toLowerCase()) > -1
                        ) {
                          if (
                            this.verified === undefined ||
                            this.verified === null ||
                            this.verified === this.consultants[i].verified
                          ) {
                            if (this.consultants[i].tech_level) {
                              if (this.data[this.consultants[i].tech_level]) {
                                this.data[this.consultants[i].tech_level].push(
                                  this.consultants[i]
                                );
                              }
                            } else {
                              this.data["general"].push(this.consultants[i]);
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        Object.keys(this.data).forEach((item) => {
          this.data[item].sort((a, b) => {
            if (a.verified !== b.verified) {
              if (a.verified) return -1;
              if (b.verified) return 1;
            }
            if (!a.created) return 1;
            if (!b.created) return -1;
            return b.created - a.created;
          });
        });
      }
    },
    onSearchFilter(event) {
      this.searchFilter = event.target.value;
      this.updateData();
    },
    onFilter: function (data) {
      this.metroFilter = data.metro;
      this.certificationFilter = data.certification;
      this.skillFilter = data.skill;
      this.levelFilter = data.level;
      // this.searchFilter = data.search;
      this.workTypes = JSON.parse(JSON.stringify(data.workTypes));
      this.workTypeFilter = data.workTypes
        .filter((item) => item.value)
        .map((item) => item.text)
        .join(",");
      this.notWorkTypes = JSON.parse(JSON.stringify(data.notWorkTypes));
      this.notWorkTypeFilter = data.notWorkTypes
        .filter((item) => item.value)
        .map((item) => item.text)
        .join(",");
      this.verified = data.verified;
      this.isActive = data.isActive;
      this.updateData();
    },
    hasWorkType: function (workType, workTypeFilter) {
      if (!workTypeFilter) return true;
      if (!workType) return false;
      const workTypeArray = workType.split(",");
      const workTypeFilterArray = workTypeFilter.split(",");
      let returnValue = false;
      returnValue = workTypeFilterArray.every((item) => {
        return workTypeArray.indexOf(item) > -1;
      });
      return returnValue;
    },
    hasNotWorkType: function (workType, notWorkTypeFilter) {
      if (!notWorkTypeFilter) return true;
      if (!workType) return false;
      const workTypeArray = workType.split(",");
      const notWorkTypeFilterArray = notWorkTypeFilter.split(",");
      let returnValue = false;
      returnValue = notWorkTypeFilterArray.every((item) => {
        return workTypeArray.indexOf(item) <= -1;
      });
      return returnValue;
    },
    viewAsConsultant: function (data) {
      const routeData = this.$router.resolve({
        path: "/home/admin/consultant_review",
        query: { id: data.id },
      });
      window.open(routeData.href, "_blank");
    },
    openEditPannel: function (action, title, isToggle) {
      if (this.editOpen && this.editOpen != action) {
        this.editOpen = action;
        this.emitEditPannel(title);
        return;
      }
      if (isToggle) {
        this.editOpen = this.editOpen ? false : action;
      } else {
        this.editOpen = action;
      }
      this.emitEditPannel(title);
    },
    closeEditPannel: function () {
      this.editOpen = false;
      this.emitEditPannel();
    },
    emitEditPannel: function (title) {
      const param = {
        title: title,
        editOpen: this.editOpen,
      };
      this.$emit("openEditPannelTitle", param);
    },
    onClickRequest: function (data) {
      this.requestPropsData = {
        clientEmail: this.clientEmail ? this.clientEmail : null,
        techEmail: data.email ? data.email : null,
        techName: data.name ? data.name : null,
      };
      this.openEditPannel(1, true);
    },
    onRequestButtonClick: function (data) {
      this.requestSubmitLoading = true;
      httpGetNoToken("create_request", data)
        .then((response) => {
          if (response.ok) {
            this.$toasted.global.toast_success({
              message: "create success",
            });
            this.closeEditPannel();
          } else {
            this.$toasted.global.toast_error({
              message: "create error",
            });
          }
        })
        .finally(() => {
          this.requestSubmitLoading = false;
        });
    },
    onClickProject: function (data) {
      if (data && data.id) {
        this.editConsultantId = data.id;
        this.openEditPannel(3, "Add to project", true);
        this.addType = "one";
      }
    },
    addAll: function (data) {
      this.openEditPannel(3, "Add to all projects", true);
      this.addType = "all";
    },
    toPublic: function () {
      const data = {
        metro: this.metroFilter,
        certification: this.certificationFilter,
        skill: this.skillFilter,
        level: this.levelFilter,
        search: this.searchFilter,
        worktypes: this.workTypeFilter,
        verified: this.verified,
      };
      const encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(data),
        "scaledesk"
      ).toString();
      const routeData = this.$router.resolve({
        path: "/public/available_techs/allinfo",
        query: { code: encrypted },
      });
      window.open(routeData.href, "_blank");
    },
    onProjectButtonClick: async function (data) {
      let send_sms = true;
      let consultants = [];
      if (this.addType === "all") {
        Object.keys(this.data).forEach((item) => {
          this.data[item].forEach((c) => {
            consultants.push(c.id);
          });
        });
      } else if (this.addType === "one") {
        consultants.push(this.editConsultantId);
      }
      if (consultants.length === 0) {
        return;
      }
      if (data.editProjectId && data.editRoleId) {
        this.projectSubmitLoading = true;
        // consultants.forEach(async (ct) => {
        for (const i in consultants) {
          const ct = consultants[i];
          const projectResult = await database.getDoc(
            "gigs",
            data.editProjectId
          );
          const project = projectResult.data.data;
          let selectedConsultants;
          if (project) {
            if (project.selected_consultants) {
              selectedConsultants = JSON.parse(
                JSON.stringify(project.selected_consultants)
              );
              const selectedConsultant = selectedConsultants.find(
                (item) => item.role_id === data.editRoleId
              );
              if (selectedConsultant) {
                const targetConsultant = selectedConsultant.consultants.find(
                  (item) => item.id === ct
                );
                if (!targetConsultant) {
                  selectedConsultant.consultants.push({
                    id: ct,
                    status: "Added",
                  });
                } else {
                  send_sms = false;
                }
              } else {
                selectedConsultants.push({
                  role_id: data.editRoleId,
                  consultants: [
                    {
                      id: ct,
                      status: "Added",
                    },
                  ],
                });
              }
            } else {
              selectedConsultants = [];
              selectedConsultants.push({
                role_id: data.editRoleId,
                consultants: [
                  {
                    id: ct,
                    status: "Added",
                  },
                ],
              });
            }
            const result = await database.updateDocById(
              "gigs",
              data.editProjectId,
              {
                selected_consultants: selectedConsultants,
              }
            );
            this.projectSubmitLoading = false;
            if (result.ok) {
              if (send_sms) {
                const smsResult = await httpGet(
                  "send_consultant_project_message",
                  {
                    projectId: data.editProjectId,
                    roleId: data.editRoleId,
                    consultantId: ct,
                  }
                );
                if (smsResult.ok) {
                  this.$toasted.global.toast_success({
                    message: "sms success",
                  });
                  this.$emit("closePanel");
                } else {
                  this.$toasted.global.toast_error({
                    message: smsResult.message,
                  });
                }
              } else {
                this.$emit("closePanel");
              }
            } else {
              this.$toasted.global.toast_error({ message: "add error" });
            }
          }
        }
        this.$toasted.global.toast_success({
          message: "success",
        });
        this.projectSubmitLoading = false;
        this.closeEditPannel();
      } else {
        this.$toasted.global.toast_error({
          message: "error",
        });
      }
    },
    toggleFilter: function () {
      this.openEditPannel(1, "Filter", true);
    },
  },
};
</script>

<style scoped>
.verified-tag {
  position: absolute;
  top: 0;
  right: 0;
}
.verified-tag::before,
.verified-tag::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  border-color: transparent;
  border-style: solid;
}

.verified-tag::before {
  border-width: 16px;
  border-right-color: transparent;
  border-top-color: transparent;
}

.verified-tag::after {
  border-width: 16px;
  border-right-color: #437512;
  border-top-color: #437512;
}
.flex-column {
  display: flex;
  flex-direction: column;
}
.flex-grow {
  flex-grow: 1;
}
.os-icon {
  opacity: 0.4;
  margin-right: 4px;
}
.client-active {
  border: 2px solid #0085ff;
  box-sizing: border-box;
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.1), 0px 3px 3px rgba(0, 0, 0, 0.06),
    0px 3px 4px rgba(0, 0, 0, 0.08);
}
.cursor-pointer {
  cursor: pointer;
}
.title-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
}
.buttons-wrapper {
  display: flex;
  align-items: center;
}
.buttons-wrapper > a {
  all: unset;
  margin-left: 10px;
}
.button {
  cursor: pointer;
  padding: 8.5px var(--padding-l);
  font-size: var(--font-size-l);
  border-radius: var(--border-radius-l);
  display: inline-block;
  background-color: var(--blue-dark);
  border: 1px solid var(--blue-dark);
  color: var(--white);
}
.button:not(:first-child) {
  margin-left: 10px;
}
.flex-left {
  flex: 0 0 360px;
}
.iframe-wrapper {
  height: 180px;
}
</style>
